<template>
    <div class="mdl-layout mdl-js-layout" id="app">
        <header class="mdl-shadow--4dp lunch-nav">
            <a class="title" v-if="!isMobile" href="/">Obědy</a>
            <router-link class="nav-link" :class="{'bigger-padding' : !isMobile}" to="/">Můj oběd</router-link>
            <router-link class="nav-link" :class="{'bigger-padding' : !isMobile}" to="/summary">Přehled obědů</router-link>
            <router-link class="nav-link" :class="{'bigger-padding' : !isMobile}" to="/administration" v-if="isAdmin()">Administrace</router-link>
            <router-link class="nav-link" :class="{'bigger-padding' : !isMobile}" to="/accounting" v-if="isAccounting()">Vyúčtování</router-link>
            <router-link class="nav-link" :class="{'bigger-padding' : !isMobile}" to="/logout">Odhlásit se</router-link>
            <span style="font-size: 12px; font-weight: 100; color: lightgray; position: absolute; right:50px; top: 14px">{{ getUserName() }}</span>
            <span style="font-size: 8px; font-weight: 100; color: lightgray; position: absolute; right:10px; top: 18px">{{ version }}</span>
        </header>
        <main class="content" >
            <router-view></router-view>
        </main>
    </div>
</template>

<script>
    //let lib = require("../node_modules/material-design-lite/material.min.js");
    import { version } from "./../package.json";

    export default {
        name: 'app',
        data: function() {
            return {
                mobileNavigation: Object,
                visible: Boolean,
                version: version
            }
        },
        methods: {
            getUserName() {
                return localStorage.getItem("vue-user-name");
            },
            isAdmin: function () {
                return localStorage.getItem("keycloak-is-admin") === "true";
            },
            isAccounting: function () {
                return localStorage.getItem("keycloak-is-accounting") === "true";
            }
        },
        computed: {
            isMobile: function() {
                return window.innerWidth < 768;
            }
        },
        mounted() {
            window.console.log("version:"+version)
            this.$nextTick(function() {
                window.addEventListener('resize', this.forceUpdate);
            });

            this.mobileNavigation = document.getElementById("mobileNavigation");
            this.visible = false;
        }
    }
</script>

<style>
    body {
        font-family: Roboto,sans-serif;
        height: 100%;
    }

    a {
        color: #666666;
    }

    .content {
        position: absolute;
        top: 50px;
        left:0px;
        right:0px;
        bottom:0px;
        overflow-y:auto;
    }

    header {
        color: white;
        background-color: #43A047;
        height: 50px;
        width: 100%;
        z-index: 3;
        overflow-x: auto;
    }

    .title {
        margin-left: 2rem;
        margin-right: 2rem;
        font-size: 1.5em;
        text-decoration: none;
        color: white;
    }

    .router-link-exact-active {
        color: rgb(255,110,64);
        background: #388E3C;
    }

    .nav-link {
        text-decoration: none;
        color: white;
        padding: 1.2rem 0.5rem 1.2rem 0.5rem;
        line-height: 50px;
    }

    .bigger-padding {
        padding: 1.2rem 2rem 1.2rem 2rem;
    }

    input:focus, textarea:focus {
        outline: 0;
    }

    input[type=text] {
        border: 0;
        width: 90%;
        margin-right: 1em;
        word-break: break-word;
        float: bottom;
        text-overflow: ellipsis;
        border-bottom: 2px solid rgba(255, 110, 64, 0);
    }

    input[type=text]:focus {
        border-bottom: 2px solid rgb(255, 110, 64);
    }

    textarea {
        border: none;
        border-bottom: 2px solid white;
        overflow: auto;
        resize: none;
        width: 90%;
        font-family: Roboto, sans-serif;
    }

    textarea:focus {
        border-bottom: 2px solid rgb(255, 110, 64);
    }
</style>
